export default "/_next/static/images/d3/4-d3226cbd317948b0dacaf4532bd6ebb3.jpg";